import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import HeroBanner from '../components/HeroBanner';
import { About } from '../components/About';
import ServiceCarousel from '../components/ServiceCarousel/ServiceCarousel';
import ServiceCarouselMobile from '../components/ServiceCarousel/ServiceCarouselMobile';
import { Gallery } from '../components/Gallery';
import GalleryMobile from '../components/Gallery/GalleryMobile';
// import { Testimonials } from '../components/Testimonials';
import StyleList from '../components/StyleList';
import QRCodeModal from '../components/QRCodeModal';
import { useQRModal } from '../hooks';

// Data imports
import heroData from '../data/hero.json';
import galleryData from '../data/gallery.json';
// import testimonialsData from '../data/testimonials.json';
import aboutData from '../data/about.json';
import servicesData from '../data/services.json';
import stylistsData from '../data/stylists.json';

// Shared animation preset for consistency - Premium feel
const sectionMotion = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: [0.16, 1, 0.3, 1] as [number, number, number, number], // Softer easing
    },
  },
};

const HomePage: React.FC = () => {
  const { isOpen, openModal, closeModal } = useQRModal();

  const handleBookingClick = () => {
    openModal();
  };

  return (
      <div className="bg-white dark:bg-custom-dark min-h-screen">
      {/* SEO Meta Tags */}
      <SEO 
        title="Barber Innovations | Best Barber Shop in Roselle, NJ"
        description="Barber Innovations is a top-rated barber shop in Roselle, NJ offering fades, beard trims, straight razor shaves, and modern men's grooming. Call (732) 581-6834 to book your appointment today."
        canonical="https://www.barberinnovations.com/"
        keywords="barber roselle nj, skin fade roselle, beard trim nj, hot towel shave roselle, best barber roselle nj, kids haircut roselle"
      />

      {/* QR Code Modal */}
      <QRCodeModal 
        isOpen={isOpen} 
        onClose={closeModal} 
      />

      {/* Hero Section */}
      <section id="home">
        <HeroBanner 
          data={heroData as any}
          onCtaClick={handleBookingClick} 
        />
      </section>

      {/* Services Section - Desktop or Mobile */}
      <motion.section
        id="services"
        className="scroll-mt-[96px]"
        variants={sectionMotion}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-120px' }}
      >
        {/* Mobile - Show on screens < 1024px */}
        <div className="lg:hidden">
          <ServiceCarouselMobile data={servicesData as any} onBookClick={openModal} />
        </div>
        
        {/* Desktop - Show on screens >= 1024px */}
        <div className="hidden lg:block">
          <ServiceCarousel data={servicesData as any} onBookClick={openModal} />
        </div>
      </motion.section>

      {/* PREVIOUS VERSION - Services Section with API Data (COMMENTED OUT)
      {apiServices.length > 0 && (
        <motion.section
          id="services"
          className="scroll-mt-[96px]"
          variants={sectionMotion}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-120px' }}
        >
          <Services data={servicesData as any} />
        </motion.section>
      )}
      */}

      {/* Stylists Section */}
      <motion.section
        id="stylists"
        className="scroll-mt-[96px]"
        variants={sectionMotion}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-120px' }}
      >
        <StyleList data={stylistsData as any} />
      </motion.section>

      {/* About Section */}
      <motion.section
        id="about"
        className="scroll-mt-[96px]"
        variants={sectionMotion}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-120px' }}
      >
        <About data={aboutData as any} />
      </motion.section>

      {/* Gallery Section - Desktop or Mobile */}
      <motion.section
        id="gallery"
        className="scroll-mt-[96px]"
        variants={sectionMotion}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-120px' }}
      >
        {/* Mobile - Show on screens < 1024px */}
        <div className="lg:hidden">
          <GalleryMobile data={galleryData as any} />
        </div>
        
        {/* Desktop - Show on screens >= 1024px */}
        <div className="hidden lg:block">
          <Gallery data={galleryData as any} />
        </div>
      </motion.section>

      {/* Testimonials Section */}
      {/* <motion.section
        id="testimonials"
        className="scroll-mt-[96px]"
        variants={sectionMotion}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-120px' }}
      >
        <Testimonials data={testimonialsData as any} />
      </motion.section> */}
    </div>
  );
};

export default HomePage;
